const CHANGE_TAB_RECURRENCE = {
  monthly: true,
  annual: false,
};

export default CHANGE_TAB_RECURRENCE;
